import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getNotifications, type Notification } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useNotificationsForClient(clientId?: number): UseQueryResult<Notification, AxiosError> {
    const queryKey = useMemo(() => queryKeys.notificationsForClient(clientId), [clientId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getNotifications({ path: { clientId: clientId! }, signal }).then((result) => result.data),
        enabled: !!clientId,
    });
}
